import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Tabs } from 'react-tabs'
import { withRouter } from 'react-router-dom'

import { history } from '../util'
class RoutedTabs extends Component {
  static propTypes = {
    tabs: PropTypes.array
  }

  static defaultProps = {
    tabs: []
  }

  onSelect = tabIndex => {
    history.mergeQueryString({ tab: this.props.tabs[tabIndex] })
  }

  render () {
    const { tabs, children, location } = this.props
    const tab = location.query ? location.query.tab : null
    let selectedIndex = tabs.indexOf(tab)
    selectedIndex = selectedIndex < 0 ? 0 : selectedIndex

    return (
      <Tabs forceRenderTabPanel selectedIndex={selectedIndex} onSelect={this.onSelect}>
        {children}
      </Tabs>
    )
  }
}

export default withRouter(RoutedTabs)



// WEBPACK FOOTER //
// ./client/src/components/RoutedTabs.js